import { render, staticRenderFns } from "./MhLink.vue?vue&type=template&id=600bb2c3&scoped=true"
import script from "./MhLink.vue?vue&type=script&lang=js"
export * from "./MhLink.vue?vue&type=script&lang=js"
import style0 from "./MhLink.vue?vue&type=style&index=0&id=600bb2c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600bb2c3",
  null
  
)

export default component.exports